var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6057 1.72744C25.4536 2.66774 24.0999 3.55854 23.5815 3.73176C22.7462 4.05344 22.6886 4.12767 22.6886 5.38964C22.6886 6.13198 22.7462 6.72585 22.8326 6.72585C23.2935 6.72585 25.2232 5.88454 26.0585 5.34016L27.0089 4.72154V6.20622V7.71564H29.8892H32.7694V4.74628C32.7694 1.55423 32.5102 0.737659 31.4157 0.317001C29.774 -0.326359 28.8523 -0.0541682 26.6057 1.72744Z",
    fill: "url(#paint0_linear_11_964)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30046 11.9466C2.93059 18.3802 0.107976 23.7746 0.021569 23.9725C-0.0936399 24.2447 0.223185 24.2942 1.6921 24.2447L3.50664 24.1705L5.03316 21.3248L6.53087 18.4792L12.3777 18.405L18.2246 18.3555L19.7799 21.3248L21.3352 24.2942H23.2938H25.2523L23.697 21.3743C22.8617 19.7907 19.9527 14.3963 17.2741 9.3732L12.4065 0.291927L6.30046 11.9466ZM14.5955 11.3775C15.7188 13.6045 16.6405 15.5099 16.6405 15.6583C16.6405 15.9058 8.51823 15.98 8.2302 15.7326C8.1438 15.6583 8.89266 13.9757 9.92954 11.9714C10.9664 9.96707 11.9169 8.06173 12.0609 7.74005C12.2049 7.41837 12.3777 7.19567 12.4353 7.24516C12.4929 7.29465 13.4434 9.15049 14.5955 11.3775Z",
    fill: "url(#paint1_linear_11_964)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3261 18.2074L27.2396 13.3327L27.1532 8.45801H29.9183H32.6833L32.8561 13.0852L33.0001 17.7372L31.704 20.7066C30.9839 22.3397 30.2927 23.7502 30.2063 23.8739C30.0911 23.9729 29.3998 22.7356 28.6798 21.1272L27.3261 18.2074ZM28.9308 19.2219L30.1779 21.8201L31.4251 19.2219H28.9308Z",
    fill: "url(#paint2_linear_11_964)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_964",
    x1: 22.6886,
    y1: 7.71564,
    x2: 30.1363,
    y2: -2.01519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4081BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_964",
    x1: 0,
    y1: 24.2942,
    x2: 23.9714,
    y2: -0.925623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4081BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_964",
    x1: 27.1532,
    y1: 8.45801,
    x2: 37.3773,
    y2: 12.3343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4081BF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogo);
export default __webpack_public_path__ + "static/media/dashboard-logo.894904f66fc078bf52a60a882e970470.svg";
export { ForwardRef as ReactComponent };